export type SeasonalityDisplayMode = 'index' | 'volume';
export type MarketplaceSearchPlatform = 'wb' | 'ozon';

export interface PlatformVerificationKeyword {
  keywordRu: string;
  selected: boolean;
}

export function defaultSeasonalityDisplayMode(volumeAvailable: boolean): SeasonalityDisplayMode {
  return volumeAvailable ? 'volume' : 'index';
}

export type SeasonalityWordstatStatus =
  'pending' | 'queued' | 'running' | 'completed' | 'cache_hit' | 'failed' | 'insufficient_balance';

export interface SeasonalityWordstatObservation {
  keyword: string;
  region: string;
  status: SeasonalityWordstatStatus;
  phraseVolume: number | null;
}

const IN_PROGRESS_STATUSES: readonly SeasonalityWordstatStatus[] = ['pending', 'queued', 'running'];
const COMPLETED_STATUSES: readonly SeasonalityWordstatStatus[] = ['completed', 'cache_hit'];

export function seasonalityAutoRecalculationKey(
  previous: SeasonalityWordstatObservation | undefined,
  current: SeasonalityWordstatObservation,
) {
  if (!previous) return null;
  if (!IN_PROGRESS_STATUSES.includes(previous.status)) return null;
  if (!COMPLETED_STATUSES.includes(current.status)) return null;
  if (current.phraseVolume == null || current.phraseVolume <= 0) return null;
  if (
    previous.keyword.trim().toLocaleLowerCase('ru-RU') !==
      current.keyword.trim().toLocaleLowerCase('ru-RU') ||
    previous.region !== current.region
  )
    return null;
  return [
    current.keyword.trim().toLocaleLowerCase('ru-RU'),
    current.region,
    current.phraseVolume,
  ].join('|');
}

export function resolvePlatformVerificationKeyword(
  keywords: readonly PlatformVerificationKeyword[],
  mainKeyword: string,
) {
  const available = keywords.filter((item) => item.keywordRu.trim());
  const selected = available.filter((item) => item.selected);
  const fallback = mainKeyword.trim() || available[0]?.keywordRu.trim() || '';

  if (selected.length === 0 || selected.length === available.length) return fallback;
  return selected[0]?.keywordRu.trim() || fallback;
}

export function buildPlatformSearchUrl(platform: MarketplaceSearchPlatform, activeKeyword: string) {
  const keyword = activeKeyword.trim();
  if (!keyword) return '';
  const encodedKeyword = encodeURIComponent(keyword);
  return platform === 'ozon'
    ? `https://www.ozon.ru/search/?text=${encodedKeyword}`
    : `https://www.wildberries.ru/catalog/0/search.aspx?search=${encodedKeyword}`;
}
